import React from 'react'
import { Box } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BlockBuilder } from 'src/v3/components/show-notes-editor'
import { ShowNotesBlock } from 'src/v3/components/show-notes-editor/types'

// Create a query client for this component
let showNotesQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always consider stale so refetches work immediately
      gcTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 1,
    },
  },
})

interface ShowNotesTabProps {
  // Required prop for backend integration
  showNotesID: string
  showNotesName?: string
  showNotesDescription?: string
  // Props for managing show notes state - updated for block system
  showNotesBlocks?: ShowNotesBlock[]
  setShowNotesBlocks?: (blocks: ShowNotesBlock[]) => void
  showNotesSaving?: boolean
  setShowNotesSaving?: (saving: boolean) => void
  // Legacy props for backward compatibility
  showNotesContent?: string
  setShowNotesContent?: (content: string) => void
  showNotesOutput?: any
  setShowNotesOutput?: (output: any) => void
}

export function ShowNotesTab({
  showNotesID,
  showNotesName,
  showNotesDescription,
  setShowNotesBlocks,
}: ShowNotesTabProps) {
  // Show Notes handlers - now using React Query
  let handleShowNotesBlocksChange = (blocks: ShowNotesBlock[]) => {
    // Notify parent component of changes
    setShowNotesBlocks?.(blocks)
  }

  return (
    <Box>
      <QueryClientProvider client={showNotesQueryClient}>
        <BlockBuilder
          showNotesID={showNotesID}
          basePath="v2/create/show-notes"
          showNotesName={showNotesName}
          showNotesDescription={showNotesDescription}
          onBlocksChange={handleShowNotesBlocksChange}
        />
      </QueryClientProvider>
    </Box>
  )
}
